import {Address, Partner, Service} from ".";
import {RRDate} from "../../..";
import {Product} from "./product";

export class Booking extends Product {
  public readonly type = "Booking";
  orderAddress: Address;
  partner: Partner;
  serviceDate: RRDate;
  problemDescription: string;
  bookingReasons: number[];

  constructor(
    service: Service,
    orderAddress: Address,
    partner: Partner,
    serviceDate: RRDate,
    problemDescription?: string,
    bookingReasons?: number[]
  ) {
    super(service);
    this.orderAddress = orderAddress;
    this.partner = partner;
    this.serviceDate = serviceDate;
    this.problemDescription = problemDescription ? problemDescription : "";
    this.bookingReasons = bookingReasons ?? [];
  }
}
